export const APPLIANCE_KINDS = [
    'oven',
    'stovetop',
    'grill',
    'steamer',
    'fryer',
    'proofer',
    'other',
];
export const PREHEATS = ['hot', 'cold', 'unknown'];
export const OVEN_MODES = [
    'bottom',
    'topBottom',
    'convection',
    'trueConvection',
    'convectionRoast',
    'broil',
    'convectionBroil',
    'steam',
    'proof',
    'custom',
];
export const HEAT_SOURCES = ['top', 'bottom', 'rear', 'fan'];
/**
 * The canonical heat sources of each mode (equipment.md). `steam` and `proof` run a function or
 * a program, not elements: they have none. `custom` has none either; a step may state its own.
 */
export const OVEN_MODE_HEAT = {
    bottom: ['bottom'],
    topBottom: ['top', 'bottom'],
    convection: ['bottom', 'fan'],
    trueConvection: ['rear', 'fan'],
    convectionRoast: ['top', 'bottom', 'fan'],
    broil: ['top'],
    convectionBroil: ['top', 'fan'],
    steam: [],
    proof: [],
};
export const COVERS = ['open', 'covered', 'closed', 'unknown'];
export const STEAM_SOURCES = ['function', 'manual', 'none'];
export const EQUIPMENT_KINDS = ['support', 'vessel', 'appliance'];
export const EQUIPMENT_SHAPES = [
    'pullman',
    'loafPan',
    'dutchOven',
    'cloche',
    'skillet',
    'pot',
    'roundPan',
    'sheet',
    'stone',
    'steel',
    'baguetteTray',
    'rack',
    'other',
];
export const MATERIALS = [
    'castIron',
    'enamelledCastIron',
    'carbonSteel',
    'stainlessSteel',
    'aluminizedSteel',
    'aluminium',
    'ceramic',
    'stoneware',
    'cordierite',
    'glass',
    'silicone',
    'other',
    'unknown',
];
export const COATINGS = [
    'none',
    'nonStick',
    'silicone',
    'enamel',
    'seasoning',
    'other',
    'unknown',
];
export const HEATERS = ['top', 'bottom', 'rear', 'other'];
export const MODE_MAPPINGS = ['documented', 'approximate', 'unknown'];
export const MODE_FANS = ['on', 'off', 'cycling', 'unknown'];
export const MODE_CONTROLS = ['setpoint', 'level', 'both'];
//# sourceMappingURL=types.js.map